<div class="left-content">
  <app-field *ngFor="let field of fields$ | async" [field]="field"></app-field>
</div>
